(function () {
  'use strict';
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---- Header: hide on scroll down, show on scroll up ---- */
  var header = qs('[data-header]');
  var lastY = window.pageYOffset;
  var toTop = qs('[data-to-top]');
  window.addEventListener('scroll', function () {
    var y = window.pageYOffset;
    if (header) {
      if (y > lastY && y > 160) header.classList.add('is-hidden');
      else if (y < lastY) header.classList.remove('is-hidden');
    }
    if (toTop) toTop.classList.toggle('is-visible', y > 700);
    lastY = y;
  }, { passive: true });
  if (toTop) toTop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });

  /* ---- Mobile nav ---- */
  var navBtn = qs('[data-nav-toggle]');
  var nav = qs('[data-nav]');
  if (navBtn && nav) {
    navBtn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      navBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---- Gallery ---- */
  qsa('[data-gallery]').forEach(function (g) {
    var track = qs('[data-gallery-track]', g);
    var thumbs = qsa('[data-thumb]', g);
    var slides = qsa('[data-slide]', g);
    if (!track || !slides.length) return;
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function current() { return Math.round(track.scrollLeft / track.clientWidth); }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-thumb'), 10)); });
    });
    var prev = qs('[data-gallery-prev]', g), next = qs('[data-gallery-next]', g);
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var c = current();
        thumbs.forEach(function (th, i) { th.classList.toggle('is-active', i === c); });
      }, 60);
    }, { passive: true });
  });

  /* ---- Bundles: only toggles quantity and shows pre-rendered strings (no price parsing) ---- */
  qsa('[data-buybox]').forEach(function (box) {
    var cards = qsa('[data-bundle]', box);
    var qty = qs('[data-qty-input]', box);
    var atcText = qs('[data-atc-text]', box);
    var stickyText = qs('[data-sticky-text]');
    function select(card) {
      cards.forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      if (qty) qty.value = card.getAttribute('data-qty');
      var txt = card.getAttribute('data-btn-text');
      var el = document.createElement('textarea');
      el.innerHTML = txt;           /* decode &ndash; */
      txt = el.value;
      if (atcText) atcText.textContent = txt;
      if (stickyText) stickyText.textContent = txt;
    }
    cards.forEach(function (c) { c.addEventListener('click', function () { select(c); }); });
    if (cards.length) select(cards[0]);
  });

  /* ---- Sticky add-to-cart bar: show once the buy box has scrolled away ---- */
  var sticky = qs('[data-sticky-atc]');
  var buy = qs('[data-buybox]');
  if (sticky && buy && 'IntersectionObserver' in window) {
    var btn = qs('[data-sticky-atc] .btn');
    new IntersectionObserver(function (entries) {
      var out = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', out);
      sticky.setAttribute('aria-hidden', out ? 'false' : 'true');
      if (btn) btn.tabIndex = out ? 0 : -1;
    }, { threshold: 0 }).observe(buy);
  }

  /* ---- Carousels ---- */
  qsa('[data-carousel]').forEach(function (c) {
    var track = qs('[data-carousel-track]', c);
    var step = function () {
      var card = track.firstElementChild;
      return card ? card.getBoundingClientRect().width + 20 : 300;
    };
    var p = qs('[data-carousel-prev]', c), n = qs('[data-carousel-next]', c);
    if (p) p.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (n) n.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* ---- FAQ: keep one item open at a time ---- */
  qsa('[data-accordion]').forEach(function (acc) {
    var items = qsa('details', acc);
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  });

  /* ---- Delivery timeline: real dates counted in business days from today ---- */
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }
  function fmt(d) {
    try { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
    catch (e) { return (d.getMonth() + 1) + '/' + d.getDate(); }
  }
  qsa('[data-delivery]').forEach(function (sec) {
    var min = parseInt(sec.getAttribute('data-min'), 10);
    var max = parseInt(sec.getAttribute('data-max'), 10);
    if (!min || !max) return;
    var today = new Date();
    var s = qs('[data-date-start]', sec), e = qs('[data-date-end]', sec);
    if (s) s.textContent = 'Today, ' + fmt(today);
    if (e) e.textContent = fmt(addBusinessDays(today, min)) + ' – ' + fmt(addBusinessDays(today, max));
  });

  /* ---- Video: make sure muted autoplay starts ---- */
  qsa('video[autoplay]').forEach(function (v) {
    v.muted = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  });
})();
